// react
import { createContext, useState } from "react";
// provider
import { HelmetProvider } from "react-helmet-async";
// types
import type { FC, PropsWithChildren } from "react";

interface HelmetInitialStateTypes {
  title: string;
  onTitleChange: (newTitle: string) => void;
}
const HelmetInitialState: HelmetInitialStateTypes = {
  title: "Arshco",
  onTitleChange: (newTitle) => {},
};
export const HelmetContext = createContext(HelmetInitialState);

export const HelmetContextProvider: FC<PropsWithChildren> = (props) => {
  const { children } = props;
  const [title, setTitle] = useState(HelmetInitialState.title);

  function onTitleChange(newTitle: string) {
    setTitle(newTitle);
  }

  return (
    <HelmetProvider>
      <HelmetContext.Provider value={{ title, onTitleChange }}>
        {children}
      </HelmetContext.Provider>
    </HelmetProvider>
  );
};
